// extracted by mini-css-extract-plugin
export var container = "SmallLinksBar-module--container--6QVf3";
export var iconButton = "SmallLinksBar-module--iconButton--XRXbA";
export var iconWrapper = "SmallLinksBar-module--iconWrapper--YUJf2";